import "../../utils/tailwind.css";
import { X, AlertCircle, LogOut } from "lucide-react";

export default function Modal(props) {
  const {
    isModalOpen,
    setIsOpen,
    title = "",
    desc = "",
    handleSubmit,
    confirmButtonLabel = "Save",
    cancelButtonLabel = "Discard",
    variant = "default", // "default" or "danger"
    size = "md", // "sm" or "md"
    children,
    showFooter = true,
  } = props;

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleSaveClick = () => {
    handleSubmit && handleSubmit();
    handleClose();
  };

  if (!isModalOpen) return null;

  const isDanger = variant === "danger" || title.toLowerCase().includes("logout");
  const isSmall = size === "sm";

  return (
    <div className="fixed inset-0 flex items-center justify-center z-[9999] px-4 animate-fade-in">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-[#0f0f3a]/60 backdrop-blur-sm"
        onClick={handleClose}
      />

      {/* Modal Card */}
      <div className={`bg-white rounded-3xl shadow-[0_20px_70px_rgba(0,0,0,0.25)] w-full overflow-hidden relative z-10 animate-slide-up ${isSmall ? "max-w-[360px]" : "max-w-[550px]"}`}>
        {/* Header/Icon Area */}
        <div className={`px-4 py-4 flex flex-col items-center text-center ${isDanger ? "bg-red-50" : "bg-[#f4f6fb]"}`}>
          <button
            onClick={handleClose}
            className="absolute top-4 right-4 p-2 rounded-full hover:bg-black/5 transition-colors text-gray-400 hover:text-gray-600"
          >
            <X size={18} />
          </button>

          {!children && (
            <div className={`w-14 h-14 rounded-2xl flex items-center justify-center mb-3 ${isDanger ? "bg-red-100 text-red-600 shadow-sm" : "bg-[#1e1e5c]/10 text-[#1e1e5c]"}`}>
              {title.toLowerCase().includes("logout") ? (
                <LogOut size={28} />
              ) : (
                <AlertCircle size={28} />
              )}
            </div>
          )}

          <h3 className={`font-bold text-[#1e1e5c] mb-1 ${isSmall ? "text-xl" : "text-2xl"}`}>{title}</h3>
          {desc && <p className={`text-[#64748b] leading-relaxed px-4 ${isSmall ? "text-sm" : "text-[15px]"}`}>{desc}</p>}
        </div>

        {/* Content Area */}
        {children && (
          <div className="px-6 py-4 max-h-[70vh] overflow-y-auto custom-scrollbar">
            {children}
          </div>
        )}

        {/* Footer/Actions */}
        {showFooter && (
          <div className={`px-4 py-3 bg-white flex flex-col sm:flex-row gap-3 ${isSmall ? "p-4" : "p-6"}`}>
            <button
              onClick={handleClose}
              className="flex-1 px-4 py-2.5 rounded-xl border border-[#e2e8f0] text-[#64748b] font-semibold hover:bg-gray-50 transition-all active:scale-95 text-sm"
            >
              {cancelButtonLabel}
            </button>
            <button
              onClick={handleSaveClick}
              className={`flex-1 px-4 py-2.5 rounded-xl font-semibold text-white shadow-lg transition-all active:scale-95 text-sm ${isDanger
                ? "bg-gradient-to-r from-red-500 to-red-600 hover:shadow-red-200"
                : "bg-gradient-to-r from-[#1e1e5c] to-[#2a2a72] hover:shadow-indigo-300 shadow-indigo-200"
                }`}
            >
              {confirmButtonLabel}
            </button>
          </div>
        )}

        <style>{`
          @keyframes slideUp {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .animate-slide-up {
            animation: slideUp 0.3s ease-out forwards;
          }
        `}</style>
      </div>
    </div>
  );
}
